import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as MaterialUI from '@mui/material';
import * as MaterialUIStyles from '@mui/material/styles';
import * as EmotionReact from '@emotion/react';
import * as EmotionStyled from '@emotion/styled';
import App from './App';

ReactDOM.render(
  <App />,
  document.getElementById('root')
 );
 
window.React = React;
window.ReactDOM = ReactDOM;
window.MaterialUI = MaterialUI;
window.MaterialUIStyles = MaterialUIStyles;
window.EmotionReact = EmotionReact;
window.EmotionStyled = EmotionStyled;
